<template>
    <div>
        <public-title :showBack='isGroup'>日历管理</public-title>
        <div class="load-area">
            <calendar class="p-4 bg-white" />
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Calendar from './Comps/Calendar'

export default {
    name: 'StoreCldList',
    components:{ Calendar },
    computed:{
        ...mapGetters(['isGroup'])
    },
    data() {
        return {
            
        }
    },
}
</script>